import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="App-footer">
      <Container>
        <Row className="align-items-center">
          <Col md={3} xs={3} className="d-flex align-items-center">
            <a href="https://www.orderq.co.za">
              <img
                src="/logo-white-no-slogan.png"
                alt="OrderQ Logo"
                style={{
                  maxHeight: '2rem', // Slightly reduced for mobile
                }}
                className="img-fluid"
              />
            </a>
          </Col>
          <Col md={6} xs={9}>
            <p className="mt-3" style={{ color: '#cbd5e0' }}>
              &copy; 2025 OrderQ. All rights reserved. Built to eliminate queues and boost your business.
            </p>
          </Col>
        </Row>

      </Container>
    </footer>
  );
};

export default Footer;